import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DeliveryInformation, GetDeliveryMomentsResponse } from '@next/core-lib/cart';
import { AbstractDialog, AbstractDialogData, AbstractDialogResultData, DIALOG_RETURN_TYPES, AgrDialogModule } from '@next/core-lib/dialog';
import { LocaleService } from '@next/core-lib/i18n';

import { UntilDestroy } from '@ngneat/until-destroy';

import { ProductDeliveryInformationComponent } from 'src/app/product/components/product-delivery-information/product-delivery-information.component';

import { SiloProductItemViewModel } from '../../models/silo-product-list.models';

export interface SiloProductListDeliveryDateDialogData extends AbstractDialogData {
  productListItem?: SiloProductItemViewModel;
  deliveryInformation?: DeliveryInformation;
}

export interface SiloProductListDeliveryDateDialogResult {
  deliveryInformation: DeliveryInformation;
}

@UntilDestroy()
@Component({
  selector: 'app-silo-product-list-delivery-date',
  templateUrl: 'silo-product-list-delivery-date-dialog.component.html',
  styleUrls: ['silo-product-list-delivery-date-dialog.component.scss'],
  imports: [AgrDialogModule, ProductDeliveryInformationComponent],
})
export class SiloProductListDeliveryDateDialogComponent extends AbstractDialog<SiloProductListDeliveryDateDialogData> implements OnInit {
  selectableDeliveryMoments: GetDeliveryMomentsResponse | null;
  initialDeliveryInformation: DeliveryInformation;
  private selectedDeliveryInformation: DeliveryInformation | null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SiloProductListDeliveryDateDialogData,
    protected readonly mdDialogRef: MatDialogRef<SiloProductListDeliveryDateDialogComponent, AbstractDialogResultData<SiloProductListDeliveryDateDialogResult>>,
    private readonly localeService: LocaleService,
  ) {
    super();
    this.initialDeliveryInformation = data.deliveryInformation;
    this.selectedDeliveryInformation = data.deliveryInformation;
  }

  ngOnInit(): void {
    this.data.title = this.localeService.translate('delivery-date.tab-title');
    this.data.subTitle = this.data.productListItem?.title;
    this.data.confirmButton = true;
    this.data.confirmButtonText = this.localeService.translate('delivery-date.confirm');
  }

  cancel() {
    this.mdDialogRef.close({ status: DIALOG_RETURN_TYPES.cancel });
  }

  confirmDeliveryDate() {
    this.mdDialogRef.close({ status: DIALOG_RETURN_TYPES.confirm, result: { deliveryInformation: this.selectedDeliveryInformation } });
  }

  handleDeliveryInformationIsValidChange(isDataValid: boolean): void {
    this.data.disableConfirmButton = !isDataValid;
  }

  handleDeliveryInformationChange(selectedDeliveryInformation: DeliveryInformation): void {
    this.selectedDeliveryInformation = {
      ...selectedDeliveryInformation,
      deliveryDate: selectedDeliveryInformation?.deliveryDate?.split('.')[0] + 'Z',
      possibleDeliveryDays: selectedDeliveryInformation?.possibleDeliveryDays,
    };
  }
}
